export default __webpack_public_path__ + "static/media/francine4.7f512c9e.jpg";